<!--
=========================================================
* Tracking App
=========================================================

* Product Page: https://therealdevs.pro/
* Copyright 2019 The Real Devs (https://therealdevs.pro/)

Coded by https://therealdevs.pro/

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div
    v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start'
    ]"
    v-if="this.$store.state.showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
    <!-- nav -->
    <navbar
      :class="[navClasses]"
      :textWhite="
        this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      "
      :minNav="navbarMinimize"
      v-if="this.$store.state.showNavbar"
    />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />
    <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : ''
      ]"
    />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import axios from 'axios';

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter
  },
  data() {
    return {
      lastUpdateTime: 0,
      minInterval: 15000,
      backgroundTickId: null,
    }
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),

    // Sincroniza los datos con la capa Nativa (Java)
    updateTrackingConfig() {
      if (window.cordova && window.cordova.plugins.backgroundMode) {
        window.cordova.plugins.backgroundMode.configure({
          token: localStorage.getItem("accessToken"),
          userId: localStorage.getItem('userId'),
          apiURL: `${this.$store.state.apiURL}tracking_log`,
          title: 'Monitoreo de Campo Activo',
          text: 'Sincronizando ubicación en tiempo real...',
          color: '2dce89',
          resume: true,
          hidden: false,
          silent: false
        });
        console.log("✅ Configuración Nativa actualizada.");
      }
    },

    forceLocationUpdate() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          this.sendLocationToBackend(latitude, longitude);
        },
        (err) => { console.log("Error pulso GPS JS:", err); },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    },

    initGlobalTracking() {
      if (localStorage.getItem('userLevel') == 1) return;

      if (window.cordova) {
        document.addEventListener('deviceready', () => {
          this.updateTrackingConfig(); // Primero datos
          this.setupCordovaTracking(); // Luego permisos
        }, false);
      } else {
        this.setupWebTracking();
      }
    },

    async setupCordovaTracking() {
      const permissions = window.cordova.plugins.permissions;
      const postNotif = "android.permission.POST_NOTIFICATIONS";

      // 1. Notificaciones (Obligatorio para el icono de la barra superior)
      permissions.requestPermission(postNotif, (status) => {
        if (status.hasPermission) {
          this.checkGeoPermissions();
        } else {
          console.warn("Sin permiso de notificación el servicio podría ser cerrado.");
          this.checkGeoPermissions();
        }
      });
    },

    checkGeoPermissions() {
      const permissions = window.cordova.plugins.permissions;
      const fineLoc = permissions.ACCESS_FINE_LOCATION;

      permissions.requestPermission(fineLoc, (status) => {
        if (status.hasPermission) {
          // 3. Background Location (Permitir todo el tiempo)
          permissions.requestPermission(
            permissions.ACCESS_BACKGROUND_LOCATION,
            (bgStatus) => {
              if (bgStatus.hasPermission) {
                this.activateBackgroundMode();
              } else {
                alert("Importante: Selecciona 'Permitir todo el tiempo' en los ajustes de ubicación.");
                permissions.manageAppPermissions();
              }
            },
            () => permissions.manageAppPermissions()
          );
        }
      });
    },

    activateBackgroundMode() {
      // eslint-disable-next-line no-undef
      const bg = window.cordova.plugins.backgroundMode;

      // Ajustes Android 14
      bg.overrideBackButton();
      if (bg.disableWebViewOptimizations) bg.disableWebViewOptimizations();
      if (bg.disableBatteryOptimizations) bg.disableBatteryOptimizations();

      bg.enable();

      bg.on('activate', () => {
        console.log("Background JS Pulso activo");
        if (this.backgroundTickId) clearInterval(this.backgroundTickId);
        this.backgroundTickId = setInterval(() => {
          this.forceLocationUpdate();
        }, 15000);
      });

      this.startWatchPosition();
    },

    setupWebTracking() { this.startWatchPosition(); },

    startWatchPosition() {
      if ("geolocation" in navigator) {
        navigator.geolocation.watchPosition(
          (position) => {
            const now = Date.now();
            if (now - this.lastUpdateTime >= this.minInterval) {
              this.sendLocationToBackend(position.coords.latitude, position.coords.longitude);
            }
          },
          (error) => console.error("Error GPS Watch:", error),
          { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
        );
      }
    },

    async sendLocationToBackend(lat, lng) {
      const token = localStorage.getItem("accessToken");
      const userId = localStorage.getItem('userId');
      if (!token || !userId) return;

      try {
        this.lastUpdateTime = Date.now();
        await axios.post(`${this.$store.state.apiURL}tracking_log`, {
          user: parseInt(userId),
          latitude: lat,
          longitude: lng
        }, {
          timeout: 8000,
          headers: { 'Authorization': `Bearer ${token}` }
        });
        console.log("📍 JS Reporte:", lat, lng);
      } catch (error) {
        console.error("Error reporte JS:", error.message);
      }
    }
  },
  mounted() {
    this.initGlobalTracking();
    setTimeout(() => {
        console.log("🔄 Re-sincronización de seguridad...");
        this.updateTrackingConfig();
    }, 3000);
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  }
};
</script>
<style>
.swal2-styled.swal2-confirm:hover,
.swal2-styled.swal2-confirm:focus{
  background-image:linear-gradient(310deg, rgb(11, 146, 87), rgb(11, 146, 87)) !important;
}
</style>
